import { render, staticRenderFns } from "./BallLoader.vue?vue&type=template&id=f11a53fc"
import script from "./BallLoader.vue?vue&type=script&lang=js"
export * from "./BallLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports